export default { sha: 'f4e0c6f2dac17e6960243ec3c2bb0b5f8df19d59', buildNumber: 'undefined' }
